import {FontStyle} from "./StyleSettings";

export class FontStylesExtractor {
    static extractStyles(styles: string[]): FontStyle[] {
        const fontStyles = Object.values(FontStyle);
        return styles.map(style => style.toLowerCase())
            .filter(style => fontStyles.some(fontStyle => fontStyle === style))
            .map(style => style as FontStyle);
    }
}